module.exports = __webpack_public_path__ + "static/media/taxijoin_01.25137cb8.png";